import {
  GetDecorationDocument,
  ListUserDecorationsDocument,
  ToggleDecorationDocument,
  UserDecorationRelationBaseFragmentDoc,
} from 'src/services/apollo/generated/graphql'
import {
  createMutationHelper,
  createQueryHook,
  modifyQueryHook,
} from 'src/services/apollo/utils'

export const useDecoration = modifyQueryHook(
  createQueryHook(GetDecorationDocument),
  {
    reduce: res => res?.decoration,
  },
)

export const useListUserDecorations = modifyQueryHook(
  createQueryHook(ListUserDecorationsDocument),
  {
    reduce: r => r?.user?.decorations,
  },
)

export const [useToggleDecoration, executeToggleDecoration] =
  createMutationHelper(ToggleDecorationDocument, {
    update(cache, { data }) {
      const { id, isEnabled } = data?.toggleDecorationV2 ?? {}

      if (id != null && isEnabled != null) {
        const cacheId = cache.identify({
          __typename: 'UserDecorationRelation',
          id,
        })

        cache.updateFragment(
          {
            fragment: UserDecorationRelationBaseFragmentDoc,
            fragmentName: 'UserDecorationRelationBase',
            id: cacheId,
          },
          data => {
            if (data) return { ...data, isEnabled }
            return undefined
          },
        )
      }
    },
    refetchQueries: [ListUserDecorationsDocument],
  })
